import { render, staticRenderFns } from "./StickyEvent.vue?vue&type=template&id=2ce02dcf&scoped=true&"
import script from "./StickyEvent.vue?vue&type=script&lang=js&"
export * from "./StickyEvent.vue?vue&type=script&lang=js&"
import style0 from "./StickyEvent.vue?vue&type=style&index=0&id=2ce02dcf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce02dcf",
  null
  
)

export default component.exports